/* eslint-disable react/prop-types */
import React, { useMemo } from 'react';

import { CloseCircleBulk, InfoCircleBulk, TickCircleBulk } from 'ui/components/Icon';

import { AlertInterface } from './types';

import { StyledAlert } from './styled';

export const Alert: AlertInterface = ({ type, closable, showIcon = true, ...props }) => {
  const icon = useMemo(() => {
    switch (type) {
      case 'success':
        return <TickCircleBulk />;
      case 'error':
        return <CloseCircleBulk />;
      default:
        return <InfoCircleBulk />;
    }
  }, [type]);

  return <StyledAlert icon={icon} closable={closable} type={type} showIcon={showIcon} {...props} />;
};

Alert.ErrorBoundary = StyledAlert.ErrorBoundary;
